'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MobilePanelHeader from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelHeader';
const textPath = 'appMarketplace.storefront.filters';
const StyledHeaderAction = styled(UIButton).withConfig({
  displayName: "MobileFilterDrilldownWrapper__StyledHeaderAction",
  componentId: "sc-1v103jb-0"
})(["&&&&{padding:4px;}"]);

const MobileFilterDrilldownWrapper = ({
  applyFilters,
  children,
  onPanelClose,
  onPanelOpen,
  searchEnabled,
  title
}) => {
  const drilldownWrapperRef = useRef(null);
  const computedPanelBodyClassName = useMemo(() => "p-x-6 p-bottom-5 " + (searchEnabled ? 'p-top-3' : 'p-top-2'), [searchEnabled]);
  useEffect(() => {
    if (onPanelOpen) {
      drilldownWrapperRef.current.focus();
    }
  }, [onPanelOpen]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
      itemLeft: /*#__PURE__*/_jsxs(StyledHeaderAction, {
        buttonRef: drilldownWrapperRef,
        use: "transparent",
        onClick: onPanelClose,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "left",
          color: CALYPSO,
          size: "xs"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.allFilters`
        })]
      }),
      itemRight: /*#__PURE__*/_jsx(StyledHeaderAction, {
        className: "p-right-3",
        use: "transparent",
        onClick: applyFilters,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.apply`
        })
      }),
      title: title
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      className: computedPanelBodyClassName,
      children: children
    })]
  });
};

MobileFilterDrilldownWrapper.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  children: PropTypes.node,
  onPanelClose: PropTypes.func.isRequired,
  onPanelOpen: PropTypes.func.isRequired,
  searchEnabled: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};
export default MobileFilterDrilldownWrapper;